/* Centralised CEF brand links - update real URLs here. */
export const CEF_LINKS = {
  website: "https://lecef.org/",
  instagram: "https://www.instagram.com/cef_belgique/",
  tiktok: "https://www.tiktok.com/@cef_belgique",
  whatsapp_channel: "https://chat.whatsapp.com/CO7fQBSVNQMDNJ8pXTRW34",
  discord: null,
  youtube: null,
  email: "contact@lecef.org",
};

export const CEF_HANDLES = {
  instagram: "@cef_belgique",
  tiktok: "@cef_belgique",
};
